import EventObserver from './models/EventObserver';

const win = (window as any);
win.StepObserver = new EventObserver();

if (window.navigator.userAgent.match(/MSIE|Trident/) === null) {
  console.log(`%c[Observer ${win.StepObserver.version}]`, 'color:#0E6397;font-weight:bold;');
} else {
  console.log(`[Observer ${win.StepObserver.version}]`);
}
